"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.function.name");

require("core-js/modules/web.dom.iterable");

var _objectSpread2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/objectSpread2"));

var _waves = _interopRequireDefault(require("@/directive/waves"));

var _moment = _interopRequireDefault(require("moment"));

var _Pagination = _interopRequireDefault(require("@/components/Pagination"));

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

var _PermissionPage = _interopRequireDefault(require("@/components/Page/PermissionPage"));

var _PermissionSimplePage = _interopRequireDefault(require("@/components/Page/PermissionSimplePage"));

var _LineChart = _interopRequireDefault(require("@/components/Charts/LineChart"));

var _store = _interopRequireDefault(require("@/store"));

var _lang = _interopRequireDefault(require("@/lang"));

var _validate = require("@/utils/validate");

var _vuex = require("vuex");

var _elementUi = require("element-ui");

var _CustomTableColumn = _interopRequireDefault(require("@/mixins/CustomTableColumn"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// waves directive
// secondary package based on el-pagination
// Custom Table Column Mixins (Omega Theme)
var _default = {
  name: "exportedExcel:view",
  mixins: [_CustomTableColumn.default],
  extends: _PermissionPage.default,
  components: {
    Pagination: _Pagination.default,
    PermissionSimplePage: _PermissionSimplePage.default
  },
  directives: {
    waves: _waves.default
  },
  data: function data() {
    return {
      rerender: false,
      tableKey: 0,
      list: null,
      total: 0,
      chartLoading: true,
      listLoading: true,
      time: null,
      channelOption: null,
      statisticalText: null,
      agentList: null,
      organizationList: null,
      updateDialogVisible: false,
      queryParameter: {
        pageNum: 1,
        pageSize: 10,
        role: null,
        agentId: null,
        orgCode: null,
        timeList: [new Date(Date.now()), new Date(Date.now())],
        createStartTime: null,
        createEndTime: null
      },
      addInformationParameter: {
        id: "",
        userName: "",
        filename: "",
        status: "",
        serviceName: "",
        remark: ""
      },
      multipleSelection: []
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['roleOptions', 'excelStatusOptions', 'exportedExcelServiceOptions'])),
  created: function created() {
    this.setDefaultTime();
    this.getList();
    this.getAgent();
    this.getOrganizationList();
  },
  mounted: function mounted() {},
  methods: {
    setDefaultTime: function setDefaultTime() {
      var date = new Date(),
          y = date.getFullYear(),
          m = date.getMonth(),
          d = date.getDate();
      var startTime = new Date(y, m, d);
      var endTime = new Date(y, m, d);
      startTime.setHours(0, 0, 0, 0);
      endTime.setHours(23, 59, 59, 0);
      this.queryParameter.timeList = [this.dateFormat(startTime), this.dateFormat(endTime)];
    },
    dateFormat: function dateFormat(date) {
      if (date == undefined) {
        return "";
      }

      return (0, _moment.default)(date).format("YYYY-MM-DD HH:mm:ss");
    },
    getAgent: function getAgent() {
      var _this = this;

      _httpUtils.default.post("agent", "getAllAgents", null, null).then(function (res) {
        //let index;
        _this.agentList = res.data;
      }).catch(function (err) {
        _this.$notify({
          title: _this.$t("common.error"),
          message: _this.$t("common.fetchError") + ',' + err.message,
          type: "error"
        });
      });
    },
    getOrganizationList: function getOrganizationList() {
      var _this2 = this;

      _httpUtils.default.post("organization", "getAllOrganizations", null, null).then(function (res) {
        //let index;
        _this2.organizationList = res.data;
      });
    },
    getList: function getList() {
      var _this3 = this;

      if (!this.hasViewPermission) {
        return;
      }

      ;
      this.listLoading = true;
      var params = this.getQueryParams();

      _httpUtils.default.post("exportedExcel", "list", null, params).then(function (res) {
        _this3.list = res.data.rows;
        _this3.total = res.data.total;
        setTimeout(function () {
          _this3.listLoading = false;
        }, 1 * 1000);
        _this3.statisticalText = null;
      }).catch(function (err) {
        _this3.$message({
          type: "error",
          message: err.message
        });
      });
    },
    handleUpdateCheck: function handleUpdateCheck(row) {
      this.updateDialogVisible = true;
      this.addInformationParameter.id = row.id;
      this.addInformationParameter.userName = row.userName;
      this.addInformationParameter.filename = row.filename;
      this.addInformationParameter.status = row.status;
      this.addInformationParameter.serviceName = row.serviceName;
      this.addInformationParameter.remark = row.remark;
    },
    handleUpdate: function handleUpdate() {
      var _this4 = this;

      var params = {
        id: this.addInformationParameter.id,
        status: this.addInformationParameter.status,
        remark: this.addInformationParameter.remark
      };

      _httpUtils.default.post("exportedExcel", "update", null, params).then(function (_) {
        _this4.handleClose();

        _this4.handleFilter();
      }).catch(function (err) {
        _this4.$message({
          type: "error",
          message: err.message
        });
      });
    },
    handleClose: function handleClose() {
      this.updateDialogVisible = false;
      this.handleReset();
    },
    handleReset: function handleReset() {
      this.addInformationParameter.remark = null;
    },
    handleExport: function handleExport(row) {
      var excelName = row.filename;
      var params = {
        id: row.id
      };

      _httpUtils.default.getByBlob("exportedExcel", "excel", params, excelName);

      _elementUi.MessageBox.confirm(_lang.default.t("warningMessage.pleaseWaitForExportMessage"), _lang.default.t("warningMessage.pleaseWaitForExportAndNavigateTitle"), {
        cancelButtonText: _lang.default.t("warningMessage.exportAndNavigateCancelButtonText"),
        type: 'warning'
      }).then(function () {
        return null;
      }).catch(function () {
        return null;
      }); // this.$message({
      //   message: i18n.t(
      //     "warningMessage.pleaseWaitForExportMessage"
      //   ),
      //   type: "info",
      //   showClose: true
      // });

    },
    handleBatchExport: function handleBatchExport() {
      if (this.multipleSelection.length == 0) {
        this.$message({
          message: _lang.default.t("warningMessage.selectExcelToDownloadMessage"),
          type: "info"
        });
      }

      for (var item in this.multipleSelection) {
        this.handleExport(this.multipleSelection[item]);
        setTimeout(function () {}, 1 * 1000);

        if (item == this.multipleSelection.length - 1) {
          this.$refs.table.clearSelection();
        }
      }
    },
    deleteExportedExcel: function deleteExportedExcel(excelIds) {
      var _this5 = this;

      _httpUtils.default.post("exportedExcel", "batchDelete", null, excelIds).then(function (res) {
        if (res.code === 200) {
          _this5.$message({
            message: _lang.default.t('warningMessage.deleteRecordSuccessMessage'),
            type: 'success'
          });

          _this5.handleFilter();
        } else {
          _this5.$message({
            message: res.message,
            type: 'error'
          });
        }
      }).catch(function (err) {
        _this5.$message({
          message: err.message,
          type: 'error'
        });
      });
    },
    handleDelete: function handleDelete(row) {
      var _this6 = this;

      // let params = {id: row.id};
      var content = _lang.default.t('warningMessage.deleteExcelConfirmMessage') + " " + row.filename + "?";
      this.$confirm(content, _lang.default.t('warningMessage.deleteExcelMessage'), {
        confirmButtonText: _lang.default.t('common.confirm'),
        cancelButtonText: _lang.default.t('common.cancel'),
        type: 'warning'
      }).then(function () {
        var excelIds = [];
        excelIds.push(row.id);

        _this6.$nextTick(function (_) {
          _this6.deleteExportedExcel(excelIds);
        });
      }).catch(function (_) {});
    },
    handleBatchDelete: function handleBatchDelete() {
      var _this7 = this;

      if (!this.multipleSelection.length) {
        this.$message({
          message: _lang.default.t('warningMessage.selectExcelToDeleteMessage'),
          type: 'error'
        });
      } else {
        this.$confirm(_lang.default.t('warningMessage.batchDeleteExcelConfirmMessage'), _lang.default.t('warningMessage.batchDeleteExcelMessage'), {
          confirmButtonText: _lang.default.t('common.confirm'),
          cancelButtonText: _lang.default.t('common.cancel'),
          type: 'warning'
        }).then(function () {
          var excelIds = [];

          for (var item in _this7.multipleSelection) {
            excelIds.push(_this7.multipleSelection[item].id);
          }

          _this7.$nextTick(function (_) {
            _this7.deleteExportedExcel(excelIds);
          });
        }).catch(function (_) {});
      }
    },
    handleFilter: function handleFilter() {
      this.queryParameter.pageNum = 1;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getQueryParams: function getQueryParams() {
      if (this.queryParameter.timeList === null || this.queryParameter.timeList === '') {
        this.setDefaultTime();
      }

      return {
        pageNum: this.queryParameter.pageNum,
        pageSize: this.queryParameter.pageSize,
        role: this.queryParameter.role,
        agentId: this.queryParameter.agentId,
        orgCode: this.queryParameter.orgCode,
        status: this.queryParameter.status,
        serviceName: this.queryParameter.serviceName,
        createStartTime: this.queryParameter.timeList[0],
        createEndTime: this.queryParameter.timeList[1]
      };
    },
    convertExcelStatusName: function convertExcelStatusName(key) {
      var found = "";
      this.excelStatusOptions.forEach(function (status) {
        if (status.key === key) {
          found = status.display_name;
          return;
        }
      });
      return found;
    },
    convertRoleName: function convertRoleName(name) {
      var found = name;
      this.roleOptions.forEach(function (role) {
        if (role.name === name) {
          found = role.display_name;
          return;
        }
      });
      return found;
    },
    convertServiceName: function convertServiceName(key) {
      var found = key;
      this.exportedExcelServiceOptions.forEach(function (service) {
        if (service.key === key) {
          found = service.display_name;
          return;
        }
      });
      return found;
    },
    convertOperatorName: function convertOperatorName(name) {
      var found = _lang.default.t("option.unknownChannelOperator");

      this.channelOperatorList.forEach(function (status) {
        if (status.key === name) {
          found = status.display_name;
          return;
        }
      });
      return found;
    }
  }
};
exports.default = _default;